export default class HDateTime {
    #datetime = null;//new Date();
    #year; #month; #day; #hour; #minute; #second;
    constructor(d) {
        //if ( d typeof 'Date' )
        if (d == null) this.#datetime = new Date(Date.now());
        else this.#datetime = new Date(d);
        //console.log("new HDateTime ", JSON.stringify(this.#datetime));
        this.#split();
    }
    static #numPad = (num, places) => String(num).padStart(places, '0');
    #split() {
        this.#year = this.#datetime.getFullYear();
        this.#month = this.#datetime.getMonth() + 1;
        this.#day = this.#datetime.getDate();

        this.#hour = this.#datetime.getHours();
        this.#minute = this.#datetime.getMinutes();
        this.#second = this.#datetime.getSeconds();
    }
    toDMY_HMS() {
        let r = this.#year + "-" + HDateTime.#numPad(this.#month, 2) + "-" + HDateTime.#numPad(this.#day, 2) + " " + this.#hour
            + ":" + HDateTime.#numPad(this.#minute, 2) + ":" + HDateTime.#numPad(this.#second, 2);
        return r;
    }
    toDMY_HMS_Dahua() {
        let r = this.#year + "_" + HDateTime.#numPad(this.#month, 2) + "_" + HDateTime.#numPad(this.#day, 2) + "_" + this.#hour
            + "_" + HDateTime.#numPad(this.#minute, 2) + "_" + HDateTime.#numPad(this.#second, 2);
        return r;
    }
    toDMY() {
        //console.log(this.#year);
        let r = new String(this.#year + "-" + HDateTime.#numPad(this.#month, 2) + "-" + HDateTime.#numPad(this.#day, 2));
        return r;
    }
    static Parse = (d) => {
        let dt = Date.parse(d);
        //console.log(dt);
        return new HDateTime(dt);
    }
    addSecounds(sec) {
        this.#datetime.setSeconds(this.#datetime.getSeconds() + sec);
        this.#split();
    }

    TimeHMS() {
        let r = this.#hour + ":" + HDateTime.#numPad(this.#minute, 2) + ":" + HDateTime.#numPad(this.#second, 2);
        return r;
    }
    GetTime() {
        let htime = new HTime(this.#datetime);
        return htime;
    }
}
export class HTimeFormat {
    static get HMS() { return "HMS"; }
    static get HMSMs() { return "HMSMs"; }
    static get Ms() { return "Ms"; }
    static get MMS() { return "MMS"; }
}

export class HTime {

    #hour = 0; #minute = 0; #second = 0; #ms = 0;

    constructor(d = null) {
        let dt;
        if (d == null) {
            dt = new Date(Date.now());
        } else {
            dt = new Date(d);
        }
        this.#split(dt);
    }
    valueOf() {
        return this.ToMs();
    }
    static FromHDateTime(dt) {
        let ret = new HTime();
        ret.#split(new Date(dt));
        return ret;
    }
    #split(dt) {
        this.#hour = dt.getHours();
        this.#minute = dt.getMinutes();
        this.#second = dt.getSeconds();
        this.#ms = dt.getMilliseconds();;
    }
    static #numPad = (num, places) => String(num).padStart(places, '0');
    static Diff(from, what) {
        let ms = from.ToMs() - what.ToMs();
        if (ms < 0) ms *= -1;
        let ht = HTime.Parse(ms);
        //console.log("Time: " + from.ToString() + " - " + what.ToString() + " = " + ht.ToString());
        return ht;
    }
    static Add(to, what) {
        let ms = to.ToMs() + what.ToMs();
        let ht = HTime.Parse(ms);
        //console.log("Time: " + from.ToString() + " - " + what.ToString() + " = " + ht.ToString());
        return ht;
    }
    ToMs() {
        return (this.#hour * 60 * 60 * 1000) + (this.#minute * 60 * 1000) + (this.#second * 1000) + parseInt(this.#ms);
    }
    ToString(format = null) {
        switch (format) {
            default:
            case HTimeFormat.HMSMs:
                return this.#hour + ":" + HTime.#numPad(this.#minute, 2) + ":" + HTime.#numPad(this.#second, 2) + "." + HTime.#numPad(this.#ms, 3);
            case HTimeFormat.HMS:
                return this.#hour + ":" + HTime.#numPad(this.#minute, 2) + ":" + HTime.#numPad(this.#second, 2);
            case HTimeFormat.Ms:
                return (this.#hour * 60 * 60 * 1000) + (this.#minute * 60 * 1000) + (this.#second * 1000) + parseInt(this.#ms);
            case HTimeFormat.MMS:
                return (this.#hour * 60) + (this.#minute) + ":" + HTime.#numPad(this.#second, 2);
        }
    }
    #zero() {
        this.#hour = this.#minute = this.#second = this.#ms = 0;
    }
    static Parse = (d) => {
        //console.log("Parse");
        const regs = [
            {
                type: "hmsms",
                reg: "^([0-9]+):([0-9]+):([0-9]+).([0-9]+)$"
            }, {
                type: "hms",
                reg: "^([0-9]+):([0-9]+):([0-9]+)$"
            }, {
                type: "ms",
                reg: "^[0-9]+$"
            }, {
                type: "mm_s",
                reg: "^([0-9]+),([0-9]+)$"
            }
        ]
        let s = String(d);
        //console.log(s);
        let obj;
        regs.forEach(function (el) {
            let reg = new RegExp(el.reg);
            if (reg.test(s)) {
                let f = reg.exec(s);
                obj = new HTime();
                obj.#zero();
                //console.log(f, el.type);
                switch (el.type) {
                    case "hmsms":
                        obj.#ms = f[4];
                    case "hms":
                        obj.#hour = f[1];
                        obj.#minute = f[2];
                        obj.#second = f[3];
                        break;
                    case "ms":
                        obj.#ms = parseInt(s);
                        obj.#hour = parseInt(obj.#ms / 3600000);
                        obj.#ms = obj.#ms - (obj.#hour * 3600000);
                        obj.#minute = parseInt(obj.#ms / 60000);
                        obj.#ms = obj.#ms - (obj.#minute * 60000);
                        obj.#second = parseInt(obj.#ms / 1000);
                        obj.#ms = obj.#ms - (obj.#second * 1000);
                        break;
                    case "mm_s":
                        console.log(f);
                        obj.#minute = parseInt(f[1]);
                        obj.#second = parseInt(f[2]);
                        obj.#hour = parseInt(obj.#minute / 60);
                        obj.#minute = obj.#minute - (obj.#hour * 60);
                        break;
                }
                console.log("T: ", obj.#hour, obj.#minute, obj.#second, obj.#ms);
                //console.log("return: ", obj);
                return obj;
            }
            return null;
        });
        //console.log("Return map: ", objret);
        return obj;
    }
}